import { IClientePortfolio } from 'app/domains/core/settings/portfolio/interfaces/cliente-portfolio-response.interface';
import { IPeriodicidadeCompra } from '../../../domains/environment/periodicidade-compra/interfaces/periodicidade-compra.interface';
import { IAiMetadata } from '../../../domains/shared/interfaces/ai-metadata.interface';
import { BaseEntity, Representavel } from '../../../models';
import { OrigemLancamentoCadastro } from '../../../models/origem-lancamento-cadastro';
import { ArquivoUpload } from '../../arquivos/arquivos/upload';
import { AtividadeClienteRevisao } from '../../atividade/cliente/atividade-cliente-revisao';
import { Campanha } from '../../campanhas/campanhas';
import { ClassificacaoFaturamento } from '../../classificacao-faturamento';
import { ClienteGrupo } from '../../cliente-grupo';
import { ClienteGrupoEconomico } from '../../cliente-grupo-economico';
import { ClienteTipo } from '../../cliente-tipo';
import { CanalVenda } from '../../common/canais-venda/domain';
import { OrigemID } from '../../common/origens/domain';
import { CondicaoPagamento } from '../../condicao-pagamento';
import { Lead } from '../../crm/lead/lead';
import { FormaPagamento } from '../../forma-pagamento';
import { MotivoPerdaVenda } from '../../motivo-perda-venda';
import { Regiao } from '../../regiao/regiao';
import { TabelaPreco } from '../../tabela-preco/tabela-preco';
import { Usuario } from '../../usuario';
import { Pessoa } from '../pessoa';
import { Representante } from '../representante';
import { Transportadora } from '../transportadora/transportadora';
import { ClienteCadastroSituacaoHistorico } from './cadastro-situacao';
import { ClienteCentralCompraParticipante } from './central-compra/participante';
import { ClienteClassificacao } from './classificacao';
import { ClienteConcorrente } from './concorrente';
import { IClienteContrato } from './interfaces/cliente-contrato.interface';
import { IClienteLogistica } from './interfaces/cliente-logistica.interface';
import { ClienteECommerce, ClienteInterneter } from './internet';
import { ClienteItemTipo } from './item-tipo';
import { ClientePrazoPagamento } from './prazo-pagamento';
import { ClienteUnidadeNegocio } from './unidade-negocio2';

export class Cliente
  implements
    BaseEntity,
    Representavel,
    ClienteInterneter,
    IClienteLogistica,
    IClienteContrato {
  readonly id: number;
  origemCadastro: number;
  idPessoa: number;
  pessoa: Pessoa;
  dataCadastro: Date;
  cadastroNovo: boolean; // Se é um cadastro novo
  cadastroCompleto: boolean; // Se o cadastro do cliente possui todas as informações necessárias e está completo
  cadastro: number;
  situacao: number;
  carteiraInativaTemperatura: number;

  /** Origem */
  origem: OrigemID;
  // Campanha
  idCampanhaOrigem: number;
  campanhaOrigem: Campanha;
  nomeCampanhaOrigem?: string;
  // Mídia Social
  canalMidiaSocial: number;
  // Canal de Venda
  idCanalVendaOrigem: number;
  canalVendaOrigem: CanalVenda;

  // Aquisição
  dataAquisicao: Date;
  idCampanhaAquisicao: number;
  campanhaAquisicao: Campanha;
  nomeCampanhaAquisicao?: string;
  idNotaFiscalAquisicao: number;
  idPedidoAquisicao: number;

  // Lead
  idLead: number;
  lead: Lead;

  // Congelado
  dataCongelamento: Date;
  idUsuarioCongelamento: number;
  usuarioCongelamento: Usuario;
  idMotivoCongelamento: number;
  motivoCongelamento: MotivoPerdaVenda;
  justificativaCongelamento: string;

  // Bloqueio
  dataBloqueio: Date;
  idUsuarioBloqueio: number;
  usuarioBloqueio: Usuario;
  motivoBloqueio: string;
  // Baixa
  dataPreBaixa: Date;
  preBaixaManual: boolean;
  idUsuarioPreBaixa: number;
  nomeUsuarioPreBaixa: string;
  usuarioPreBaixa: Usuario;
  dataBaixa: Date;
  baixaManual: boolean;
  idUsuarioBaixa: number;
  nomeUsuarioBaixa: string;
  usuarioBaixa: Usuario;
  motivoBaixa: string;
  // Revisão
  revisaoStatus: number;
  revisaoConfirmada: boolean; // Atributo auxiliar utilizado para saber quando o usuário confirmou a revisão do cliente para podermos aplicar a lógica da confirmação da revisão
  atividadeRevisaoPendente: AtividadeClienteRevisao; // Atividade referente a revisão do cliente utilizada para atualizar as informações da atividade enquanto realiza a revisão do cliente
  dataUltimaRevisao: Date;
  idUsuarioUltimaRevisao: number;
  usuarioUltimaRevisao: Usuario;
  dataReferenciaProximaRevisao: Date;
  mesReferenciaProximaRevisao: number;
  anoReferenciaProximaRevisao: number;

  // Central de Compras
  idPeriodicidadeCompra: number;
  periodicidadeCompra: IPeriodicidadeCompra;
  periodicidadeCompraSemana: number;
  quantidadeParticipantesCentralCompras: number;

  idClienteTipo: number;
  tipo: ClienteTipo;
  codigoClienteTipoErp: number;
  nomeClienteTipoErp: string;
  idClienteGrupo: number;
  grupo: ClienteGrupo;
  idClienteGrupoEconomico: number;
  grupoEconomico: ClienteGrupoEconomico;
  clientePrimario: boolean;
  idClientePrimario: number;
  moeda: number;
  idPessoaMatriz: number;
  pessoaMatriz: Pessoa;

  // Simples Nacional
  optanteSimplesNacional: boolean;
  optanteSimplesNacionalData: Date;
  optanteSimplesNacionalDataExclusao: Date;

  // MEI
  optanteMEI: boolean;
  optanteMEIData: Date;
  optanteMEIDataExclusao: Date;

  // IPI
  isentoIpi: boolean;
  dataValidadeCartaIsencaoIpi: Date;

  // Central de compras
  idClienteCentralCompra: number;
  clienteCentralCompra: Cliente;
  /** Percentual de participação do cliente na central de compra */
  percParticipacaoCentralCompra: number;
  /** Percentual de participação total dos participantes da central de compras */
  percParticipacaoTotalCentralCompra: number;
  /** Participantes da central de compras */
  participantesCentralCompra: ClienteCentralCompraParticipante[];

  idRepresentante: number;
  representante: Representante;
  percComissaoRepresentante: number;
  parecerRepresentante: string;
  idUsuarioGerente: number;
  usuarioGerente: Usuario;
  idUsuarioAtendente: number;
  usuarioAtendente: Usuario;
  anotacao: string;

  // Informações comerciais
  nomeFornecedor1: string;
  foneFornecedor1: string;
  retornoFornecedor1: string;
  nomeFornecedor2: string;
  foneFornecedor2: string;
  retornoFornecedor2: string;
  nomeFornecedor3: string;
  foneFornecedor3: string;
  retornoFornecedor3: string;
  nomeFornecedor4: string;
  foneFornecedor4: string;
  retornoFornecedor4: string;
  nomeFornecedor5: string;
  foneFornecedor5: string;
  retornoFornecedor5: string;
  preferenciaVencimentoSegunda: boolean;
  preferenciaVencimentoTerca: boolean;
  preferenciaVencimentoQuarta: boolean;
  preferenciaVencimentoQuinta: boolean;
  preferenciaVencimentoSexta: boolean;
  preferenciaVencimentoSabado: boolean;
  preferenciaVencimentoDomingo: boolean;
  possuiValidadePropostaComercial: boolean;
  idTabelaPreco: number;
  tabelaPreco: TabelaPreco;

  /** Segmentação */
  tipoFiscal: number;
  // Classificações
  classificacoesNome: string;
  classificacoes: ClienteClassificacao[];

  // Região
  idRegiao: number;
  regiao: Regiao;

  // Mercado
  clienteAbc: number;
  mediaCompra: number;
  periodicidadeCompraOld: number;
  posicaoMarca: number;
  idItemTipo: number;
  itensTipos: ClienteItemTipo[];
  concorrentes: ClienteConcorrente[];
  unidadesNegocio: ClienteUnidadeNegocio[];

  // Classificação RAP
  idClassificacaoFaturamentoPretendida: number;
  classificacaoFaturamentoPretendida: ClassificacaoFaturamento;
  customerSharePretendido: number;
  indicadorCustomerSharePretendido: number;

  // Classificação RAR
  idClassificacaoFaturamentoRealizada: number;
  classificacaoFaturamentoRealizada: ClassificacaoFaturamento;
  customerShareRealizado: number;
  indicadorCustomerShareRealizado: number;

  // Internet
  emailNfe: string;
  exigeOrdemCompraComXml: boolean;
  laudo: boolean;
  emailLaudo: boolean;
  emailAprovacaoCliche: boolean;
  ecommerce: boolean;
  mercadoLivre: boolean;
  marketplace: boolean;
  eCommerces: ClienteECommerce[];

  // Análise Financeira
  statusAnaliseFinanceira: number;
  dataInicioAnaliseFinanceira: Date;
  idUsuarioInicioAnaliseFinanceira: number;
  dataConclusaoAnaliseFinanceira: Date;
  idUsuarioConclusaoAnaliseFinanceira: number;
  dataUltimaRevisaoAnaliseFinanceira: Date;
  idUsuarioUltimaRevisaoAnaliseFinanceira: number;
  anotacaoAnaliseFinanceira: string;

  // Dados Financeiros
  modoEnvioBoleto: number;
  emailBoleto: string;
  pagamentoViaPIX: boolean;
  enviarPIXPorEmail: boolean;
  emailPIX: string;
  limiteCredito: number;
  limiteCreditoDisponivel: number;
  idCondicaoPagamento: number;
  condicaoPagamento: CondicaoPagamento;
  idFormaPagamento: number;
  formaPagamento: FormaPagamento;
  tipoPagamento: number;
  prazosPagamento: ClientePrazoPagamento[];
  prazosMediosPagamento: number[] | null;

  // Logística
  observacoesLogistica: string;
  possuiRegraShelfLife: boolean;
  percShelfLife: number;
  aplicaMultaPorAtrasoLogistico: boolean;
  normasPaletizacao: string;
  tipoFrete: number;
  idTransportadora: number;
  transportadora: Transportadora;

  // Contrato
  possuiContrato: boolean;
  numeroContrato: string;
  dataInicioContrato: Date;
  dataValidadeContrato: Date;
  percDescontoContrato: number;
  urlArquivoContrato: string;
  observacoesContrato: string;
  marcosDiasNotificacaoContrato: number[] | null;
  emailsAdicionaisNotificacaoContrato: string[] | null;
  contratoVencido: boolean;
  contratoDiasParaVencer: number;
  arquivoContratoUpload: ArquivoUpload;

  // Históricos
  cadastrosSituacoesHistorico: ClienteCadastroSituacaoHistorico[];

  // Arquivos
  arquivosUpload: ArquivoUpload[];

  // Importação
  tagImportacao: string;
  dataImportacao: Date;

  // Integração ERP
  idIntegracaoErp: number;
  integradoErp: boolean;
  integracaoErpSistema: number;
  integracaoSincronizadaErp: boolean;
  dataIntegracaoErp: Date;
  dataUltimaIntegracaoErp: Date;

  // Integração ERP - SCR
  /** Informação de rota de entrega do cliente no sistema ERP SCR */
  rotaEntregaErpSCR: string;

  /** Atributos auxiliares */
  // Para o Typeahead de clientes **.
  nomeCidade: string;
  uf: string;
  cartaIsencaoIpiVencida: boolean;

  // tags
  tags: any[];
  portfolios: IClientePortfolio[];

  // AI Metadata
  aiMetadata: IAiMetadata;

  constructor(origemCadastro: OrigemLancamentoCadastro) {
    this.origemCadastro = origemCadastro?.id ?? null;
    this.pessoa = new Pessoa(origemCadastro);
    this.participantesCentralCompra = [];
    this.classificacoes = [];
    this.itensTipos = [];
    this.concorrentes = [];
    this.unidadesNegocio = [];
    this.eCommerces = [];
    this.prazosPagamento = [];
    this.clientePrimario = true;
    this.arquivosUpload = [];
  }
}
